﻿import global from './globals';

"use strict";
var privateFns;
privateFns = {
	setDefaultZoom: function () {
		global.map.getView().setCenter(global.origin);
		global.map.getView().setZoom(7);
	},
	validateEast: function (east) {
		var valid = true;
		east = parseInt(east, 10);
		if (east < 580000 || east > 640000) {
			valid = false;
		}
		return valid;
	},
	validateNorth: function (north) {
		var valid = true;
		north = parseInt(north, 10);
		if (north < 6620000 || north > 6680000) {
			valid = false;
		}
		return valid;
	},
	validateZoom: function (zoom) {
		var valid = true;
		zoom = parseInt(zoom, 10);
		if (zoom < 0 || zoom > 11) {
			valid = false;
		}
		return valid;
	},
	validateLocationHash: function (east, north, zoom) {
		var valid = true;
		if (privateFns.validateEast(east) === false) {
			valid = false;
		}
		if (privateFns.validateNorth(north) === false) {
			valid = false;
		}
		if (privateFns.validateZoom(zoom) === false) {
			valid = false;
		}
		return valid;
	},
	handleLocationTokens: function (hash) {
		var tokenArray = hash.split(",");
		if (tokenArray[0].substr(0, 2) === "cp") {
			tokenArray[0] = tokenArray[0].split("=")[1];
		}
		if (tokenArray.length >= 3 && privateFns.validateLocationHash(tokenArray[0], tokenArray[1], tokenArray[2])) {
			global.map.getView().setCenter(
				[parseInt(tokenArray[0], 10), parseInt(tokenArray[1], 10)]
			);
			global.map.getView().setZoom(parseInt(tokenArray[2], 10));
		} else {
			privateFns.setDefaultZoom();
		}
		return tokenArray;
	},
	toggleLayer: function (layerId, checked) {
		var layerInput = $("input[id='" + layerId + "']");
		layerInput.prop("checked", checked);
		layerInput.change();
	},
	setLayerVisibility: function (arr) {
		var lyrCollection = {};
		var lyrIndex = 0;
		arr.forEach(function (item) {
			lyrCollection[item] = true;
		});

		global.forAllLayers(global.map, function (lyr) {
			if (lyrCollection[lyrIndex]) {
				if (lyr.get("layerId") === "flyfoto") {
					$(".layerswitcher").find("button").click();
				} else {
					privateFns.toggleLayer(lyr.get("layerId"), true);
				}
			} else {
				privateFns.toggleLayer(lyr.get("layerId"), false);
			}
			lyrIndex += 1;
		});
	},
	enterAndSubmitSearch: function (val) {
		$("#large-search").val(decodeURIComponent(val)).closest("form").submit();
		$("#searchinput").show();
	},
	getSearchStringFromParameter: function (obj) {
		Object.keys(obj).some(function (key) {
			var done = false;
			if (obj.hasOwnProperty(key) && key !== "v") {
				privateFns.enterAndSubmitSearch(obj[key]);
				done = false;
			}
			// loop avbrytes når done === true
			return done;
		});
	},

	/**
	 * @param obj
	 * @param obj.gnr
	 * @param obj.gardsnr
	 * @param obj.gaardsnummer
	 * @param obj.bnr
	 * @param obj.bruksnr
	 * @param obj.bruksnummer
	 * @param obj.gate
	 * @param obj.gatenavn
	 * @param obj.hnr
	 * @param obj.husnr
	 * @param obj.bokstav
	 * @param obj.bkst
	 * @param obj.search
	 * @param obj.searchstring
	 * @param obj.saksnr
	 * @param obj.adresse
	 * @param obj.eiendom
	 * @param obj.list
	 */
	 //list=["123/45","123/676","123/1035"]
	searchParamValue: function (obj) {
		//var searchstr = "", searchInitiated = false, gnr, bnr, gate, hnr, bokstav;
		if (global.isEmpty(obj) === false) {
			var funksjon = obj.funksjon;
			var hint = obj.hint;
			var sesjon = obj.sesjon;
			var link2 = obj.link2;
			var gnr = obj.gnr || obj.gardsnr || obj.gaardsnummer;
			var bnr = obj.bnr || obj.bruksnr || obj.bruksnummer;
			var gate = obj.gate || obj.gatenavn;
			var hnr = obj.hnr || obj.husnr;
			var bokstav = obj.bokstav || obj.bkst;
			var list = obj.list;
			var lat = obj.lat;
			var lon = obj.lon;
			var searchstr = "", searchInitiated = false;
			if(funksjon){
				if(funksjon === "VisEiendom"){
					if(list){
						searchstr = decodeURI(list).replaceAll("\"", "").slice(1,-1);
					}else{							
						searchstr = gnr + "/" + bnr;
					}
					privateFns.enterAndSubmitSearch(searchstr);
				}
				if(hint){
					global.GIFunctions[hint](gnr + "/" + bnr, sesjon, link2, hint);
					searchInitiated = true;
				}
			}else if (gnr && bnr) {
				searchstr = gnr + "/" + bnr;
			} else if (gate && hnr) {
				searchstr = gate + " " + hnr;
				if (bokstav) {
					searchstr += bokstav;
				}
			} else {
				privateFns.getSearchStringFromParameter(obj);
				searchInitiated = true;
			}
			if (searchInitiated === false && searchstr.length > 0) {
				privateFns.enterAndSubmitSearch(searchstr);
			} else {
				privateFns.setDefaultZoom();
			}
		}
	},
	setMapMode: function (mode) {
		//Skru av default kartlag
		global.defaults.forEach(function(layer){
			if($("#"+layer)[0] && $("#"+layer)[0].checked && !$("#"+layer)[0].parentElement.parentElement.firstChild.classList.contains("mapmenu-expander")){
				$("#"+layer).click();
			}
		});
		if (global.modes[mode]) {
			if(Array.isArray(global.modes[mode].layers)){
				global.modes[mode].layers.forEach(function(layer){
					if($("#"+layer).length){
						if(layer === "temakart"){
							$("#"+layer).find("button").click();
						}else{							
							$("#"+layer).click();
						}
					}
					/*global.map.getView().fit(
						[567333, 6628570, 621043, 6670440],
						global.map.getSize()
					);*/
				});					
			}else{
				global.modes[mode].handler();
			}
		}else{
			if(mode.includes(",")){
				let modes = mode.split(",");
				modes.forEach(function(modus){
					if($("#"+modus).length){
						$("#"+modus).click();
					}
				});
			}else{					
				if($("#"+mode).length){
					$("#"+mode).click();
				}
			}
		}
		global.mapMode = mode;
	},
};
export default {
	getTokenAndParams: function () {
		var paramObject = {};
		//Henter fra og med '?' fra urlen.
		var pageurl = window.location.search.substring(1);
		var urlvariables = pageurl.split("&");
		urlvariables.forEach(function (urlVar) {
			var parametername = urlVar.split("=");
			paramObject[parametername[0]] = parametername[1];
		});
		if(paramObject.zoom){
			if(privateFns.validateZoom(paramObject.zoom)){
				global.map.getView().setCenter(global.origin);
				global.map.getView().setZoom(paramObject.zoom);
				delete paramObject["zoom"];
			}
		}else{				
			privateFns.setDefaultZoom();
		}
		if (paramObject.mode) {
			privateFns.setMapMode(paramObject.mode);
			delete paramObject["mode"];
		}
		if (paramObject.east && paramObject.north) {
			let zoom = paramObject.zoom ? paramObject.zoom : 7;
			privateFns.handleLocationTokens(paramObject.east + "," + paramObject.north+","+zoom);
			delete paramObject["north"];
			delete paramObject["east"];
			delete paramObject["zoom"];
		}else if(paramObject.lat && paramObject.lon){
			let zoom = paramObject.zoom ? paramObject.zoom : 7;
			privateFns.handleLocationTokens(paramObject.lat + "," + paramObject.lon+","+zoom);
			var clickFeature = new ol.Feature({
				name: "clickFeature",
				geometry: new ol.geom.Point([paramObject.lat, paramObject.lon]),
			});
			clickFeature.setStyle(new ol.style.Style({
				image: new ol.style.Icon({
					anchor: [0.5, 1],
					size: [32, 32],
					src: 'icons/Kart PinBlue.png',
				}),
			}));
			var markerlayer = global.map.getLayerById("fontmarkers");
			markerlayer.getSource().clear();
			markerlayer.getSource().addFeature(clickFeature);
			delete paramObject["lat"];
			delete paramObject["lon"];
			delete paramObject["zoom"];
		}
		if (paramObject.min) {
			global.appConfig.contextMenu.active = "min";
			$("#layerMenuToggler").click();
			$("#contextMinimize").click();
			delete paramObject["min"];
		}
		for(var key in paramObject){
			if(global.registeredPlugins[key]){
				global.registeredPlugins[key].handler(decodeURIComponent(paramObject[key]).split("|"), global.registeredPlugins[key]);
				delete paramObject[key];
			}
		}
		
		privateFns.searchParamValue(paramObject);
		if (paramObject.list) {
			var list = paramObject.list;
			global.listSearch = true;
			global.list = decodeURI(list);
			list = JSON.parse(decodeURI(list));
			privateFns.enterAndSubmitSearch(list);
			delete paramObject["list"];
		}
	},
};